import api from '@/utils/api'

export default {
    getFilteredErrors(filters, page, size) {
        return api.post(`/errors/search?page=${page - 1}&size=${size}`, filters)
    }
}
